import { render, staticRenderFns } from "./RequestMailDialog.vue?vue&type=template&id=3c956468&scoped=true"
import script from "./RequestMailDialog.vue?vue&type=script&lang=js"
export * from "./RequestMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c956468",
  null
  
)

export default component.exports